import { useEffect, useState } from "react";
import {
  Button,
  OverlayTrigger,
  Spinner,
  Table,
  Toast,
  Tooltip,
} from "react-bootstrap";
import { FaUserPlus } from "react-icons/fa";
import { RiFileHistoryLine } from "react-icons/ri";
import { TbBuildingMinus } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import adminApi from "../../../api/adminApi";
import adminCompanyCreditApi from "../../../api/adminCompanyCredit";
import companyUserApi from "../../../api/companyUsers";
import creditRequestApi from "../../../api/creditRequestApi";
import paymentApi from "../../../api/paymentApi";
import Pagination from "../../../components/Pagination";
import CompanyCreditRequestModal from "../credits/CompanyCreditRequestModal";
import AddUserModal from "./AddUserModal";

const AssignedComapnies = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [companies, setCompanies] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [showCreditRequestModal, setShowCreditRequestModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [requestedCredits, setRequestedCredits] = useState("");
  const [userInvitationToast, setUserInvitationToast] = useState(false);
  const [inviteEmail, setInviteEmail] = useState("");
  const [selectedRole, setSelectedRole] = useState("SENDER"); // Default value is "Sender"
  const user = JSON.parse(localStorage.getItem("user"));
  const userName = user?.userName;
  const [companyCredits, setCompanyCredits] = useState({});
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [sortedColumn, setSortedColumn] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [userInivitationToast, setUserInivitatonToast] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [showQRCodeModal, setShowQRCodeModal] = useState(false);
  const [showQR, setShowQR] = useState(false);
  const [qrImage, setQrImage] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [amountToPay, setAmountToPay] = useState(0);
  const [requestCPUnit, setRequestCPUnit] = useState("");

  const [creditPiceUnit, setCreditPiceUnit] = useState(0);
  useEffect(() => {
    fetchCreditHistory();
  }, []);

  const fetchCreditHistory = () => {
    adminApi.getCurrentCredits().then((res) => {
      setCreditPiceUnit(res.data.creditPiceUnit);
    });
  };

  // Function to fetch the assigned companies
  // const fetchCompanies = async () => {
  //   try {
  //     if (!user?.userEmail) return;

  //     const response = await companyUserApi.getAssignedCompanies(
  //       user.userEmail
  //     );
  //     setCompanies(response.data || []);
  //   } catch (error) {
  //     console.error("Error fetching companies:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const fetchCompanies = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user?.userEmail) return;

      const response = await companyUserApi.getAssignedCompanies(
        user.userEmail,
        page,
        pageSize,
        sortedColumn,
        sortOrder,
      );
      const pageData = response.data;
      const companiesData = response.data.content || [];
      setCompanies(companiesData);
      setTotalPages(pageData.totalPages || 0);

      // No duplicate setTotalPages here

      const creditPromises = companiesData.map(async (company) => {
        try {
          const res = await adminCompanyCreditApi.getCompanyCreditsByCompany(
            company.companyName,
          );
          return { name: company.companyName, credits: res.data };
        } catch (error) {
          console.error(
            `Error fetching credits for ${company.companyName}:`,
            error,
          );
          setTotalPages(0);
          setCompanies([]);
          return { name: company.companyName, credits: null };
        }
      });

      const creditResults = await Promise.all(creditPromises);

      // Map results into an object for quick lookup
      const creditsMap = {};
      creditResults.forEach((item) => {
        creditsMap[item.name] = item.credits;
      });

      setCompanyCredits(creditsMap);
    } catch (error) {
      console.error("Error fetching companies:", error);
    } finally {
      setLoading(false);
    }
  };
  // Effect to fetch companies when component mounts

  useEffect(() => {
    fetchCompanies();
  }, [page, pageSize, sortedColumn, sortOrder]);

  // Helper function to get the initials from a name
  const getInitials = (name = "") => {
    return name
      .split(" ")
      .map((word) => word[0] + word[1])
      .join("")
      .toUpperCase();
  };

  // Helper function to truncate text (if needed)
  const truncate = (text = "", length = 10) => {
    return text.length > length ? text.substring(0, length) + "..." : text;
  };

  const handleRequestForCredits = async (company) => {
    console.log(company);
    setSelectedCompany(company);
    setShowCreditRequestModal(true);
  };

  const handleShowAddUserModal = (company) => {
    console.log("Selected company: ", company);
    setSelectedCompany(company);
    setModalType("addUser");
    setShowModal(true);
  };

  const handleSendRequestForCredits = async (requestData) => {
    try {
      const response = await creditRequestApi.saveCreditPricing({
        userEmail: user?.userEmail,
        userName: user?.userName,
        companyName: selectedCompany?.companyName,
        companyId: selectedCompany?.companyId,
        credits: parseInt(requestedCredits, 10),
        mobileNumber: mobileNumber,
        frymeType: "BUSINESS",
      });
      setShowCreditRequestModal(false);

      Swal.fire({
        title: "Request Submitted!",
        text: "Your request for credits has been sent to the admin. Please wait, the admin will assign credits for you.",
        icon: "success",
        confirmButtonText: "OK",
      });

      setRequestedCredits("");
    } catch (error) {
      console.error("Error submitting credit request:", error);

      Swal.fire({
        title: "Error!",
        text: "Failed to submit your credit request. Please try again.",
        icon: "error",
        confirmButtonText: "Close",
      });
    }
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedCompany(null);
  };
  const handleSendInvite = async () => {
    console.log("Selected Company Data:", selectedCompany); // Check if selectedCompany is correctly populated

    if (!selectedCompany) {
      console.log("Selected Company is undefined or null");
      return; // Prevent further action if selectedCompany is not available
    }

    console.log("companyId:", selectedCompany.companyId); // Should log 13
    console.log("companyName:", selectedCompany.companyName);
    console.log("invite email:", inviteEmail);
    console.log("role:", selectedRole);

    const inviteUserData = {
      companyId: selectedCompany.companyId, // This should now correctly reference the value
      userEmail: inviteEmail,
      invitedByEmail: user?.userEmail,
      mobileNumber: mobileNumber,
      role: selectedRole,
    };

    try {
      await companyUserApi.inviteCompanyUser(inviteUserData);
      setUserInvitationToast(true);
      setSelectedRole(selectedRole);
      setShowModal(false);
      setInviteEmail("");
      handleClose();
      Swal.fire({
        title: "User Invited!",
        text: `An invitation has been sent to ${inviteEmail}`,
        icon: "success",
        confirmButtonText: "OK",
      });
    } catch (error) {
      console.error("Failed to invite user:", error);
      Swal.fire({
        title: "Error!",
        text: "Failed to send the invitation. Please try again.",
        icon: "error",
        confirmButtonText: "Close",
      });
    }
  };

  const handlePageSizeChange = (e) => {
    const size = parseInt(e.target.value);
    setPageSize(size);
    setPage(0);
  };

  const handlePageClick = (data) => {
    const selectedPage = Math.max(0, Math.min(data.selected, totalPages - 1)); // Ensure selectedPage is within range
    setPage(selectedPage);
    localStorage.setItem("assignedCompanies", selectedPage); // Store the page number in localStorage
  };

  const handleSort = (column) => {
    if (sortedColumn === column) {
      // Toggle sort order if the same column is clicked
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      // Sort by the new column (default to ascending)
      setSortedColumn(column);
      setSortOrder("asc");
    }
  };
  const handleInviteUser = (success) => {
    if (success) {
      fetchCompanies();
    }
  };

  const handleDeleteCompany = async (company) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: `Do you want to delete the company "${company.companyName}"? This action cannot be undone.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    console.log(company.companyId, user?.userEmail);
    if (result.isConfirmed) {
      try {
        await companyUserApi.deleteCompanyUser(
          company.companyId,
          user?.userEmail,
        );
        Swal.fire(
          "Deleted!",
          `You are deleted from the company "${company.companyName}".`,
          "success",
        );
        fetchCompanies();
      } catch (error) {
        console.error("Error deleting company:", error);
        Swal.fire(
          "Error!",
          "There was an issue deleting the company. Please try again later.",
          "error",
        );
      }
    }
  };

  const handleNext = async (requestData) => {
    console.log("handleNext function is triggered", requestData);

    try {
      if (
        !requestData ||
        !requestData.requestedCredits ||
        !requestData.mobileNumber
      ) {
        console.error("Invalid data:", requestData);
        return;
      }

      const creditsFromInput = parseInt(requestData.requestedCredits, 10);
      const cpu = creditPiceUnit;

      setRequestedCredits(creditsFromInput);
      setMobileNumber(requestData.mobileNumber);
      setRequestCPUnit(creditPiceUnit);

      console.log("creditPiceUnit:", cpu);
      console.log("requestedCredits (from argument):", creditsFromInput);

      if (!cpu || cpu === 0) {
        console.error("Invalid creditPiceUnit value:", cpu);
        return;
      }

      if (isNaN(creditsFromInput) || creditsFromInput <= 0) {
        console.error("Invalid requestedCredits value:", creditsFromInput);
        return;
      }

      const amount = cpu * creditsFromInput;
      console.log("Calculated Amount to Pay:", amount);

      setAmountToPay(amount);

      const payload = {
        userId: user?.userId,
        userEmail: user?.userEmail,
        credits: creditsFromInput,
        companyName: requestData.companyName,
        mobileNumber: requestData.mobileNumber,
      };

      const qrResponse = await paymentApi.generateQRCode(payload);
      setQrImage(qrResponse.data.qrImage);
      setTransactionId(qrResponse.data.transactionId);

      setShowQRCodeModal(true);
    } catch (error) {
      console.error("QR Generation failed", error);
      Swal.fire("Error", "Failed to generate QR Code.", "error");
    }
  };
  const handleNavigate = (company) => {
    const encodedName = encodeURIComponent(company.companyName);
    const tabValue = "assigned";
    navigate(
      `/dashboard/creditPassBook/my-companies/${encodedName}/transactionLedger`,
      { state: { tab: tabValue } },
    );
  };
  return (
    <div
      style={{ minHeight: "80vh", display: "flex", flexDirection: "column" }}
    >
      {loading ? (
        <div className="d-flex justify-content-center align-items-center">
          <Spinner animation="border" role="status" />
        </div>
      ) : companies.length === 0 ? (
        <p>No assigned companies for you.</p>
      ) : (
        <>
          <h5 className="mb-3">
            <strong>The companies list which are assigned by someone</strong>
          </h5>
          <div style={{ overflowX: "auto", width: "100%" }}>
            <Table
              striped
              bordered
              hover
              responsive
              style={{ minWidth: "1100px", whiteSpace: "nowrap" }}
            >
              <thead>
                <tr>
                  <th>#Id</th>
                  <th>Company Name</th>
                  {/* <th>Description</th> */}
                  <th>Invited By</th>
                  <th>Role</th>
                  <th>Balance Credits</th>
                  <th>Used Credits</th>
                  <th>Credit Request</th>
                  <th>Used Credits</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {companies.map((company, index) => {
                  const credits = companyCredits[company.companyName];
                  return (
                    <tr key={index}>
                      <td>{company.companyId}</td>
                      <td>
                        {company.companyName} - {getInitials(userName)}
                      </td>
                      {/* <td>
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-desc-${company.id}`}>
                            {company.description}
                          </Tooltip>
                        }
                      >
                        <span style={{ cursor: "pointer" }}>
                          {truncate(company.description)}
                        </span>
                      </OverlayTrigger>
                    </td> */}
                      <td>{company.invitedByEmail}</td>
                      <td>{company.role}</td>
                      <td>{credits ? credits.balanceCredit : "Loading..."}</td>
                      <td>{credits ? credits.usedCredit : "Loading..."}</td>

                      <td>
                        <Button
                          onClick={() => handleRequestForCredits(company)}
                        >
                          Request for Credits
                        </Button>
                      </td>
                      <td>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id={`tooltip-add-${company.id}`}>
                              Ledger of Transactions
                            </Tooltip>
                          }
                        >
                          <Button
                            variant="link"
                            onClick={() => handleNavigate(company)}
                          >
                            <RiFileHistoryLine size={30} />
                          </Button>
                        </OverlayTrigger>
                      </td>
                      <td>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip id={`tooltip-add-${company.id}`}>
                                Add Users
                              </Tooltip>
                            }
                          >
                            <Button
                              size="sm"
                              variant="success"
                              className="me-1 mb-1"
                              onClick={() => handleShowAddUserModal(company)}
                            >
                              <FaUserPlus />
                            </Button>
                          </OverlayTrigger>

                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip
                                id={`tooltip-delete-company-${company.id}`}
                              >
                                Delete Company
                              </Tooltip>
                            }
                          >
                            <Button
                              size="sm"
                              variant="danger"
                              className="me-1 mb-1"
                              onClick={() => handleDeleteCompany(company)}
                            >
                              <TbBuildingMinus />
                            </Button>
                          </OverlayTrigger>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
          {companies.length > 0 && totalPages > 0 && (
            <div style={{ marginTop: "auto" }}>
              <Pagination
                page={page}
                pageSize={pageSize}
                totalPages={totalPages}
                handlePageSizeChange={handlePageSizeChange}
                handlePageClick={handlePageClick}
              />
            </div>
          )}
        </>
      )}

      <CompanyCreditRequestModal
        show={showCreditRequestModal}
        onClose={() => setShowCreditRequestModal(false)}
        companyName={selectedCompany?.companyName}
        companyId={selectedCompany?.companyId}
        userEmail={user?.userEmail}
        onSend={handleSendRequestForCredits}
      />

      {userInivitationToast && (
        <Toast
          onClose={() => setUserInivitatonToast(false)}
          show
          delay={3000}
          autohide
          bg="success"
        >
          <Toast.Header>
            <strong className="me-auto">User Invited</strong>
          </Toast.Header>
          <Toast.Body className="text-white">
            User invitation sent successfully.
          </Toast.Body>
        </Toast>
      )}

      <AddUserModal
        show={showModal}
        onClose={handleClose}
        selectedCompany={selectedCompany}
        onInviteUser={handleInviteUser}
        loading={loading}
      />
    </div>
  );
};

export default AssignedComapnies;
